import React from 'react';
import { globalStyles } from './GlobalStyles';
import { darkTheme } from '../../stitches.config';
import 'typeface-montserrat';
import 'typeface-poppins';
import 'typeface-manrope';

globalStyles();

const themes = {
  light: 'light',
  dark: darkTheme.className,
};

export const ThemeContext = React.createContext({
  colorMode: 'light',
  setColorMode: () => { },
});

export const ThemeProvider = ({ children }) => {
  const [colorMode, rawSetColorMode] = React.useState('light');

  React.useEffect(() => {
    const root = document.documentElement;
    const initialColorMode = root.classList.contains(themes.dark)
      ? 'dark'
      : 'light';
    rawSetColorMode(initialColorMode);
  }, []);

  const contextValue = React.useMemo(() => {
    function setColorMode(newValue) {
      document.documentElement.classList.remove(themes[colorMode]);
      document.documentElement.classList.add(themes[newValue]);
      localStorage.setItem('color-mode', newValue);
      rawSetColorMode(newValue);
    }

    return {
      colorMode,
      setColorMode,
    };
  }, [colorMode, rawSetColorMode]);

  return (
    <ThemeContext.Provider value={contextValue}>
      {children}
    </ThemeContext.Provider>
  );
};
